module.exports = __webpack_public_path__ + "7f98564275a2dd461ce999c1c3e13f01.png";